export default "__VITE_ASSET__Dq3Co2Vp__"